import type {
	GetClientContractsParams,
	GetClientPropositionsParams,
	GetClientReceiptsParams,
} from "@dune/types";

export const clientsQueryKeys = {
	all: ["clients"] as const,
	lists: () => [...clientsQueryKeys.all, "lists"] as const,
	list: (
		search?: string,
		status?: string,
		type?: string,
		page?: number,
		limit?: number,
	) =>
		[...clientsQueryKeys.lists(), search, status, type, page, limit] as const,
	counts: (search?: string, type?: string) =>
		[...clientsQueryKeys.all, "counts", search, type] as const,
	details: () => [...clientsQueryKeys.all, "details"] as const,
	detail: (clientId: string, clientType?: string) =>
		[...clientsQueryKeys.details(), clientId, clientType] as const,
	constructionSites: (clientId: string, clientType?: string) =>
		[
			...clientsQueryKeys.detail(clientId, clientType),
			"construction-sites",
		] as const,
	propositions: (
		clientId: string,
		params?: GetClientPropositionsParams,
		clientType?: string,
	) =>
		[
			...clientsQueryKeys.detail(clientId, clientType),
			"propositions",
			params,
		] as const,
	contracts: (
		clientId: string,
		params?: GetClientContractsParams,
		clientType?: string,
	) =>
		[
			...clientsQueryKeys.detail(clientId, clientType),
			"contracts",
			params,
		] as const,
	receipts: (
		clientId: string,
		params?: GetClientReceiptsParams,
		clientType?: string,
	) =>
		[
			...clientsQueryKeys.detail(clientId, clientType),
			"receipts",
			params,
		] as const,
};
